"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAggregatorDisplayName = exports.capitalizeFirstLetter = exports.getCoverLimitAmount = exports.isAnnualProduct = exports.formatDateTime = exports.getDriverFieldsChangedCount = exports.flattenObjectJson = exports.getWebChatScriptValueByPolicyNumber = exports.arraysIntersect = exports.prepareQueryString = exports.isSupportPortalMtc = exports.isSupportPortalMta = exports.isCustomerPortalMta = exports.isRenewal = exports.isCustomerPortalMtc = exports.isMta = exports.findMainAnnualPaymentCard = exports.resolveClaimType = exports.formatDate = exports.getVehicleNumberOfDoors = exports.getVehicleEngineSize = exports.getInteractionVehicleFuelType = exports.validatePhoneNumber = exports.getFullAddressString = exports.capitalize = exports.isPageValid = exports.setCookie = exports.getCookieDomain = exports.getHardDeclineEndDateText = exports.getValidationStyle = exports.trimParenthesesFromString = exports.getAmountToDisplay = exports.getAmountWithDecimalDigits = exports.getAddressLine1WithPostcode = exports.getAddressLines = exports.calculateValuablesTotalValue = exports.getRegisteredKeeper = exports.getVehicleRealMainDriverAndAdditionalDrivers = exports.getVehiclePermanentDrivers = exports.getVehicleTemporaryDrivers = exports.getNeverHigherPeriodWording = exports.getNeverHigherPeriodAmount = exports.getIndexSetting = exports.getDuplicateCars = exports.getOrdinal = exports.convertDateToUkTimeZoneDate = exports.renderCoverStartDate = exports.formatFileSize = exports.convertDate = exports.convertDateTime = void 0;
exports.removeChange = exports.pushChange = exports.handleChanged = exports.getEligibleTiers = exports.tierNotCalculatedOrNotDeclined = exports.isTierNotDeclined = exports.getCoverTierWording = exports.isPolicyHolderNameValid = exports.hasPriceForTier = exports.getTierChangeWording = exports.isUpfrontPrice = exports.getInteractionPaymentAmount = exports.isBeforeIntroductionOfAllianzSilverTier = exports.isBeforeIntroductionOfAllianzEssentialsTier = exports.isBeforeIntroductionOfPersonalAccidentCover = void 0;
var moment = require("moment-timezone");
var services_1 = require("@falcon/services");
var journey_services_1 = require("@athena-portal/journey-services");
var core_1 = require("@athena-portal/core");
var DATETIME_FORMAT = "DD MMM YYYY, HH:mm";
var convertDateTime = function (inputDate) {
    return (0, exports.convertDate)(inputDate, DATETIME_FORMAT);
};
exports.convertDateTime = convertDateTime;
var convertDate = function (inputDate, format) {
    var valueAsMoment = moment.utc(inputDate, moment.ISO_8601);
    if (valueAsMoment.isValid()) {
        return (valueAsMoment.format(format));
    }
    return null;
};
exports.convertDate = convertDate;
function formatFileSize(byteSize) {
    var sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
    if (byteSize === 0) {
        return '';
    }
    var kilobyteSize = parseInt(String(Math.floor(Math.log(byteSize) / Math.log(1024))), 10);
    return Math.round(byteSize / Math.pow(1024, kilobyteSize)) + ' ' + sizes[kilobyteSize];
}
exports.formatFileSize = formatFileSize;
function renderCoverStartDate(startDate) {
    var format = DATETIME_FORMAT;
    if (moment(startDate).isSame(moment(), 'day')) {
        return (0, exports.convertDateToUkTimeZoneDate)(startDate, format);
    }
    else {
        // This is a workaround for the fact that startDate coming from database is 23:59 UTC and it needs to stay as 23:59
        // This explains why in one case startDate is rendered in UK time and in the other case as UTC
        return (0, exports.convertDate)(startDate, format);
    }
}
exports.renderCoverStartDate = renderCoverStartDate;
var convertDateToUkTimeZoneDate = function (inputDate, format) {
    var valueAsMoment = moment.utc(inputDate, moment.ISO_8601);
    if (valueAsMoment.isValid()) {
        return valueAsMoment.tz("Europe/London").format(format);
    }
    return null;
};
exports.convertDateToUkTimeZoneDate = convertDateToUkTimeZoneDate;
var getOrdinal = function (value) {
    var suffixes = ["th", "st", "nd", "rd"];
    var numberEnding = value % 100;
    return value + (suffixes[(numberEnding - 20) % 10] || suffixes[numberEnding] || suffixes[0]);
};
exports.getOrdinal = getOrdinal;
//
// Compares quote vehicles with active subscription ones and returns duplicates
//
var getDuplicateCars = function (quoteVehicles, policyVehiclesRegistrationNumbers) {
    var duplicateVehicles = [];
    if (!quoteVehicles || !policyVehiclesRegistrationNumbers) {
        return duplicateVehicles;
    }
    policyVehiclesRegistrationNumbers.forEach(function (policyVehicleRegistrationNumber) {
        var value = quoteVehicles.find(function (quoteVehicle) { return quoteVehicle.registrationNumber === policyVehicleRegistrationNumber; });
        if (value) {
            duplicateVehicles.push(value);
        }
    });
    return duplicateVehicles;
};
exports.getDuplicateCars = getDuplicateCars;
function getIndexSetting(setting, index, questionType) {
    if (index) {
        if (isNaN(index)) {
            throw Error("".concat(questionType, " widget has incorrectly set '").concat(setting, "' setting: '").concat(setting, "' must be a number"));
        }
        else if (index < 0) {
            throw Error("".concat(questionType, " widget has incorrectly set '").concat(setting, "' setting: '").concat(setting, "' must be a non-negative integer"));
        }
    }
    else if (!index && index !== 0) {
        throw Error("".concat(questionType, " widget missing 'index' setting"));
    }
    return index;
}
exports.getIndexSetting = getIndexSetting;
// Retrieves never higher amount for different scenarios
function getNeverHigherPeriodAmount(interaction) {
    // if mtaChangeAddress Quote
    if (interaction.process === services_1.INTERACTION_PROCESS_CHANGE_ADDRESS ||
        interaction.process === services_1.INTERACTION_PROCESS_MTA_CHANGE_POLICY_HOLDER_DETAILS ||
        interaction.process === services_1.INTERACTION_PROCESS_MTA_REINSTATE_SUBSCRIPTION) {
        return interaction.factors.neverHigher;
    }
    else {
        return interaction.uistate.subscriptionNeverHigher;
    }
}
exports.getNeverHigherPeriodAmount = getNeverHigherPeriodAmount;
// Retrieves never higher amount period wording
function getNeverHigherPeriodWording(interaction, subscriptionNeverHigher, policies) {
    var constraintEndDate = null;
    if (services_1.productHelper.includesMotorProduct(policies) && interaction.vehicles) {
        constraintEndDate = (0, exports.convertDate)(interaction.vehicles[0].factors.constraintEndDate, "DD MMMM YYYY");
    }
    else if (services_1.productHelper.includesRentersProduct(policies) && interaction.realEstates) {
        constraintEndDate = (0, exports.convertDate)(interaction.realEstates[0].realEstateFactors.constraintEndDate, "DD MMMM YYYY");
    }
    return (constraintEndDate) ?
        "".concat(getAmountToDisplay(subscriptionNeverHigher), " per month until ").concat(constraintEndDate, ", based on your current details") :
        "".concat(getAmountToDisplay(subscriptionNeverHigher), " for next 3 months, based on your current details");
}
exports.getNeverHigherPeriodWording = getNeverHigherPeriodWording;
function getVehicleTemporaryDrivers(vehicle, temporaryDrivers) {
    var vehicleTempDrivers = [];
    if (vehicle.driverIds && vehicle.driverIds.length !== 0 && temporaryDrivers && temporaryDrivers.length !== 0) {
        vehicle.driverIds.forEach(function (driverId) {
            var tempDriver = temporaryDrivers.find(function (driver) { return driverId === driver.personId; });
            if (tempDriver) {
                vehicleTempDrivers.push(tempDriver);
            }
        });
    }
    return vehicleTempDrivers;
}
exports.getVehicleTemporaryDrivers = getVehicleTemporaryDrivers;
function getVehiclePermanentDrivers(vehicle, permanentDrivers) {
    var vehiclePermanentDrivers = [];
    if (vehicle.driverIds && vehicle.driverIds.length !== 0 && permanentDrivers && permanentDrivers.length !== 0) {
        vehicle.driverIds.forEach(function (driverId) {
            var permanentDriver = permanentDrivers.find(function (driver) { return driverId === driver.personId; });
            if (permanentDriver) {
                vehiclePermanentDrivers.push(permanentDriver);
            }
        });
    }
    return vehiclePermanentDrivers;
}
exports.getVehiclePermanentDrivers = getVehiclePermanentDrivers;
function getVehicleRealMainDriverAndAdditionalDrivers(drivers, mainDriverId) {
    var mainDriver;
    var additionalDrivers = [];
    drivers.forEach(function (driver) {
        if (driver.personId === mainDriverId) {
            mainDriver = driver;
        }
        else {
            additionalDrivers.push(driver);
        }
    });
    return { mainDriver: mainDriver, additionalDrivers: additionalDrivers };
}
exports.getVehicleRealMainDriverAndAdditionalDrivers = getVehicleRealMainDriverAndAdditionalDrivers;
function getRegisteredKeeper(interaction, carIndex) {
    var vehicle = interaction.vehicles[carIndex];
    var allDrivers = [interaction.policyHolder].concat(interaction.additionalDrivers || []);
    var registeredKeeper = "";
    vehicle.driverIds.forEach(function (driverId) {
        var foundDriver = allDrivers.find(function (driver) { return driver.personId && (driverId === driver.personId) && (driver.personId === vehicle.registeredKeeperId); });
        if (foundDriver) {
            registeredKeeper = "".concat(foundDriver.firstName, " ").concat(foundDriver.lastName);
        }
        else {
            return;
        }
    });
    return registeredKeeper;
}
exports.getRegisteredKeeper = getRegisteredKeeper;
function calculateValuablesTotalValue(valuableItems) {
    return valuableItems.map(function (item) { return item.value; }).reduce(function (total, next) { return Number(total) + Number(next); }, 0);
}
exports.calculateValuablesTotalValue = calculateValuablesTotalValue;
function getAddressLines(address) {
    var addressComponents = getFullAddressString(address, false).split(", ");
    var convertedComponents = [];
    for (var _i = 0, _a = addressComponents.slice(0, -1); _i < _a.length; _i++) {
        var component = _a[_i];
        var addressLine = [];
        for (var _b = 0, _c = component.split(' '); _b < _c.length; _b++) {
            var separateWord = _c[_b];
            addressLine.push(separateWord.charAt(0).toUpperCase() + separateWord.slice(1).toLowerCase());
        }
        convertedComponents.push(addressLine.join(" "));
    }
    // Postcode line should have all letter in uppercase, so it is not being converted
    convertedComponents.push(addressComponents[addressComponents.length - 1]);
    return convertedComponents;
}
exports.getAddressLines = getAddressLines;
function getAddressLine1WithPostcode(address) {
    var addressLines = getAddressLines(address);
    var shortenedAddress = [];
    shortenedAddress.push(addressLines[0]);
    shortenedAddress.push(addressLines[addressLines.length - 1]);
    return shortenedAddress.join(", ");
}
exports.getAddressLine1WithPostcode = getAddressLine1WithPostcode;
function getAmountWithDecimalDigits(amount) {
    var fixedAmount = 1 * amount;
    return new Intl.NumberFormat('en-UK', { style: 'currency', currency: 'GBP' }).format(fixedAmount);
}
exports.getAmountWithDecimalDigits = getAmountWithDecimalDigits;
function getAmountToDisplay(amount) {
    if ((amount % 1) === 0) {
        return "£" + new Intl.NumberFormat('en-UK').format(amount);
    }
    else {
        return getAmountWithDecimalDigits(amount);
    }
}
exports.getAmountToDisplay = getAmountToDisplay;
function trimParenthesesFromString(name) {
    var parenthesesRegex = new RegExp("^.*[\\(\\)].*$");
    if (parenthesesRegex.test(name)) {
        return name.replace(/[()]/g, '');
    }
    else {
        return name;
    }
}
exports.trimParenthesesFromString = trimParenthesesFromString;
function getValidationStyle(isValid) {
    if (isValid) {
        return "is-valid";
    }
    if (isValid === undefined) {
        return "";
    }
    return "is-invalid";
}
exports.getValidationStyle = getValidationStyle;
function getHardDeclineEndDateText(interaction) {
    var weekLater = moment().utc().add(7, "d");
    var currentEndDate = moment(interaction.headerInfo.endDate, moment.ISO_8601).utc();
    var today = moment().utc();
    var daysBeforeEndDate = currentEndDate.isSameOrBefore(weekLater) ?
        moment.duration(currentEndDate.startOf("day").diff(today.startOf("day"))).asDays() : 7;
    var endDateString = daysBeforeEndDate === 0 ? "today" : "in " + daysBeforeEndDate + " days";
    var declineEndDate = currentEndDate.isSameOrBefore(weekLater) ?
        currentEndDate.format("DD MMMM YYYY") : weekLater.format("DD MMMM YYYY");
    return endDateString + " on " + declineEndDate;
}
exports.getHardDeclineEndDateText = getHardDeclineEndDateText;
function getCookieDomain(hostname) {
    var topLevelDomainsToCheck = [".com", ".co.uk"];
    for (var _i = 0, topLevelDomainsToCheck_1 = topLevelDomainsToCheck; _i < topLevelDomainsToCheck_1.length; _i++) {
        var tld = topLevelDomainsToCheck_1[_i];
        if (hostname.endsWith(tld)) {
            var hostnameWithoutTld = hostname.replace(new RegExp("".concat(tld, "$")), "");
            var subdomainsAndDomain = hostnameWithoutTld.split(".");
            var domain = subdomainsAndDomain[subdomainsAndDomain.length - 1];
            return domain + tld;
        }
    }
    return hostname;
}
exports.getCookieDomain = getCookieDomain;
function setCookie(name, value, millis) {
    var expires = "";
    var domain = "; domain=".concat(getCookieDomain(window.location.hostname));
    if (millis) {
        var date = new Date();
        date.setTime(date.getTime() + millis);
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "") + expires + domain + "; path=/";
}
exports.setCookie = setCookie;
function isPageValid(pageValidations, validations) {
    if (pageValidations) {
        for (var _i = 0, pageValidations_1 = pageValidations; _i < pageValidations_1.length; _i++) {
            var validation = pageValidations_1[_i];
            if (validation.valid === false && validation.errorMessage) {
                return false;
            }
        }
    }
    if (validations) {
        for (var _a = 0, _b = Object.keys(validations); _a < _b.length; _a++) {
            var questionName = _b[_a];
            var validationResult = validations[questionName];
            if (validationResult.errors && validationResult.errors.length > 0) {
                return false;
            }
        }
    }
    return true;
}
exports.isPageValid = isPageValid;
function capitalize(text) {
    return text.toLowerCase().split(' ').map(function (s) { return s.charAt(0).toUpperCase() + s.substring(1).toLowerCase(); }).join(' ');
}
exports.capitalize = capitalize;
function getFullAddressString(addressDetails, shouldCapitalize) {
    if (shouldCapitalize === void 0) { shouldCapitalize = true; }
    var fullAddressString;
    if (addressDetails.fullAddress) {
        fullAddressString = addressDetails.fullAddress;
    }
    else {
        var subBuildingName = addressDetails.subBuildingName ? addressDetails.subBuildingName : "";
        var buildingName = addressDetails.buildingName ? addressDetails.buildingName : "";
        var buildingNumber = addressDetails.buildingNumber ? addressDetails.buildingNumber.toString() : "";
        var thoroughfareName = addressDetails.thoroughfareName ? addressDetails.thoroughfareName : "";
        var thoroughfareDescriptor = addressDetails.thoroughfareDescriptor ? addressDetails.thoroughfareDescriptor : "";
        var dependentThoroughfareName = addressDetails.dependentThoroughfareName ? addressDetails.dependentThoroughfareName : "";
        var dependentThoroughfareDescriptor = addressDetails.dependentThoroughfareDescriptor ? addressDetails.dependentThoroughfareDescriptor : "";
        var dependentLocality = addressDetails.dependentLocality ? addressDetails.dependentLocality : "";
        var doubleDependentLocality = addressDetails.doubleDependentLocality ? addressDetails.doubleDependentLocality : "";
        var postCode = addressDetails.postcode ? addressDetails.postcode : "";
        var addressLine1 = [subBuildingName, buildingName].filter(function (e) { return e.length !== 0; }).join(' ');
        var addressLine2 = [buildingNumber, dependentThoroughfareName, dependentThoroughfareDescriptor, thoroughfareName, thoroughfareDescriptor].filter(function (e) { return e.length !== 0; }).join(' ');
        var addressLine3 = [doubleDependentLocality, dependentLocality].filter(function (e) { return e.length !== 0; }).join(' ');
        var addressLine4 = addressDetails.postTown ? addressDetails.postTown : "";
        fullAddressString = [addressLine1, addressLine2, addressLine3, addressLine4, postCode].filter(function (e) { return e.length !== 0; }).join(', ');
    }
    return shouldCapitalize ? capitalize(fullAddressString) : fullAddressString;
}
exports.getFullAddressString = getFullAddressString;
function validatePhoneNumber(phoneNumber) {
    var invalidPhoneRegex = /^[0][0-1]{9,10}$/;
    if (invalidPhoneRegex.test(phoneNumber)) {
        return false;
    }
    var phoneRegex = /^[0][0-9]{9,10}$/;
    return phoneRegex.test(phoneNumber);
}
exports.validatePhoneNumber = validatePhoneNumber;
function getInteractionVehicleFuelType(fuelCode, fuelTypeFull) {
    if (fuelTypeFull && fuelTypeFull.includes('/')) {
        return 'H';
    }
    else {
        return fuelCode;
    }
}
exports.getInteractionVehicleFuelType = getInteractionVehicleFuelType;
function getVehicleEngineSize(vehicle) {
    if (vehicle.engineSize) {
        return vehicle.engineSize;
    }
    else if (vehicle.lvVehicleData && vehicle.lvVehicleData.engineSizeCc) {
        return vehicle.lvVehicleData.engineSizeCc; // leaving field from vehicle data for old quotes and subscriptions
    }
    else {
        return "";
    }
}
exports.getVehicleEngineSize = getVehicleEngineSize;
function getVehicleNumberOfDoors(vehicle) {
    if (vehicle.doors) {
        return vehicle.doors;
    }
    else if (vehicle.lvVehicleData && vehicle.lvVehicleData.numberOfDoors) {
        return vehicle.lvVehicleData.numberOfDoors; // leaving field from vehicle data for old quotes and subscriptions
    }
    else {
        return "";
    }
}
exports.getVehicleNumberOfDoors = getVehicleNumberOfDoors;
function formatDate(inputDate, format) {
    var valueAsMoment = moment.utc(inputDate, moment.ISO_8601);
    if (valueAsMoment.isValid()) {
        return (valueAsMoment.format(format));
    }
    return "";
}
exports.formatDate = formatDate;
function resolveClaimType(claimTypeId) {
    var claimType = {
        "1": "Accident - you hit somebody/something",
        "2": "Accident - you/somebody hit each other",
        "3": "Accident - somebody/something hit you",
        "4": "Windscreen/Window glass",
        "5": "Malicious damage/Vandalism",
        "6": "Theft of vehicle",
        "7": "Theft from vehicle",
        "8": "Fire",
        "9": "Storm/Flood/Weather damage"
    };
    return claimType[claimTypeId];
}
exports.resolveClaimType = resolveClaimType;
function findMainAnnualPaymentCard(party, mainCardId) {
    for (var _i = 0, _a = party.paymentCards; _i < _a.length; _i++) {
        var card = _a[_i];
        if (Number(mainCardId) === card.id) {
            return card;
        }
    }
    return null;
}
exports.findMainAnnualPaymentCard = findMainAnnualPaymentCard;
/**
 * Checks if the process is any kind of MTA
 *
 * @param process
 * @returns Returns true if the process is any kind of MTA otherwise false
 */
function isMta(process) {
    return process.startsWith("mta");
}
exports.isMta = isMta;
function isCustomerPortalMtc(process) {
    return process.startsWith("mtc");
}
exports.isCustomerPortalMtc = isCustomerPortalMtc;
/**
 * Checks if the process is any kind of renewal
 *
 * @param process
 * @returns Returns true if the process is any kind of renewal otherwise false
 */
function isRenewal(process) {
    return process.startsWith("renewal");
}
exports.isRenewal = isRenewal;
/**
 * Checks if the process is an MTA from the Customer Portal
 *
 * @param process
 * @returns Returns true if the process is an MTA from the Customer Portal otherwise false
 */
function isCustomerPortalMta(process) {
    return isMta(process) && !isSupportPortalMta(process);
}
exports.isCustomerPortalMta = isCustomerPortalMta;
/**
 * Checks if the process is an MTA from the Support Portal
 *
 * @param process
 * @returns Returns true if the process is an MTA from the Support Portal otherwise false
 */
function isSupportPortalMta(process) {
    return process.startsWith("mtaSupportPortal");
}
exports.isSupportPortalMta = isSupportPortalMta;
/**
 * Checks if the process is an MTC from the Support Portal
 *
 * @param process
 * @returns Returns true if the process is an MTC from the Support Portal otherwise false
 */
function isSupportPortalMtc(process) {
    return process != null && process.startsWith("supportPortalAnnualCancellation");
}
exports.isSupportPortalMtc = isSupportPortalMtc;
/**
 * Creates query string from config string
 *
 * @param queryStringConfig Config string with values separated by `;`
 * @returns Returns query string with params from config string
 */
function prepareQueryString(queryStringConfig) {
    var queryMap = core_1.ConfigHelper.parseMapFromString(queryStringConfig);
    return core_1.ConfigHelper.mapToQueryString(queryMap);
}
exports.prepareQueryString = prepareQueryString;
/**
 * Determines if there is any intersection between two arrays.
 *
 * @param array1 - The first array to check for intersection.
 * @param array2 - The second array to check for intersection.
 * @returns Returns `true` if there is at least one common element between the arrays, otherwise `false`.
 */
function arraysIntersect(array1, array2) {
    if (!array1 || !array2) {
        return false;
    }
    var set1 = new Set(array1);
    var commonItems = array2.filter(function (item) { return set1.has(item); });
    return commonItems.length > 0;
}
exports.arraysIntersect = arraysIntersect;
function getWebChatScriptValueByPolicyNumber(policyNumber) {
    if (policyNumber.startsWith("FLH")) {
        return "home";
    }
    else if (policyNumber.startsWith("FLO")) {
        return "motor";
    }
    else {
        return undefined;
    }
}
exports.getWebChatScriptValueByPolicyNumber = getWebChatScriptValueByPolicyNumber;
function flattenObjectJson(objectPerson) {
    var target = {};
    flatObject(objectPerson, target);
    return target;
}
exports.flattenObjectJson = flattenObjectJson;
function flatObject(source, target) {
    Object.keys(source).forEach(function (k) {
        if (Array.isArray(source[k])) {
            source[k].forEach(function iter(a) {
                if (Array.isArray(a)) {
                    a.forEach(iter);
                    return;
                }
                if (a !== null && typeof a === 'object') {
                    flatObject(a, target);
                }
            });
            return;
        }
        if (source[k] !== null && typeof source[k] === 'object') {
            flatObject(source[k], target);
            return;
        }
        target[k] = source[k];
    });
}
function getDriverFieldsChangedCount(interactionPersons, policyInteractionPersons) {
    var difference = Object.keys(interactionPersons).filter(function (key) {
        if (key === "numberOfReadOnlyClaims" || key === "numberOfReadOnlyConviction" || key === "driverInfoEdited") {
            return;
        }
        else {
            var bothNullOrUndefined = (interactionPersons[key] === null || interactionPersons[key] === undefined) && (policyInteractionPersons[key] === null || policyInteractionPersons[key] === undefined);
            var diff = interactionPersons[key] !== policyInteractionPersons[key];
            return diff && !bothNullOrUndefined;
        }
    });
    return difference.length;
}
exports.getDriverFieldsChangedCount = getDriverFieldsChangedCount;
var formatDateTime = function (inputDate) {
    return formatDate(inputDate, "D MMMM YYYY, HH:mm");
};
exports.formatDateTime = formatDateTime;
function isAnnualProduct(product) {
    return product === services_1.PRODUCT_WOLF_MOTOR || product === services_1.PRODUCT_ANNUAL_HOME;
}
exports.isAnnualProduct = isAnnualProduct;
function getCoverLimitAmount(type, amountType, interaction) {
    var limit = interaction.covers.filter(function (cover) { return cover.type === type; })[0].amounts.filter(function (amount) { return amount.type === amountType; })[0];
    return limit ? limit.amount : 0;
}
exports.getCoverLimitAmount = getCoverLimitAmount;
function capitalizeFirstLetter(text) {
    var trimmedText = text.trim();
    return trimmedText.charAt(0).toUpperCase() + trimmedText.slice(1);
}
exports.capitalizeFirstLetter = capitalizeFirstLetter;
function getAggregatorDisplayName(referrerAggregator) {
    var source;
    switch (referrerAggregator) {
        case "ctm":
        case "ctmhome":
            source = "CompareTheMarket.com";
            break;
        case "cnf":
        case "cnfhome":
            source = "Confused.com";
            break;
        case "gc":
        case "gchome":
            source = "Gocompare.com";
            break;
        case "msm":
        case "msmhome":
            source = "MoneySuperMarket.com";
            break;
        case "elx":
            source = "ElectriX";
            break;
        default:
            source = "aggregator";
            console.error("Unrecognized referrer aggregator '".concat(referrerAggregator, "'"));
            break;
    }
    return source;
}
exports.getAggregatorDisplayName = getAggregatorDisplayName;
function isBeforeIntroductionOfPersonalAccidentCover(date) {
    return date && moment(date).isBefore(process.env.REACT_APP_ESSENTIALS_PERSONAL_ACCIDENT_COVER_RELEASE_DATE);
}
exports.isBeforeIntroductionOfPersonalAccidentCover = isBeforeIntroductionOfPersonalAccidentCover;
function isBeforeIntroductionOfAllianzEssentialsTier(date) {
    return date && moment(date).isBefore(process.env.REACT_APP_ALLIANZ_ESSENTIALS_TIER_RELEASE_DATE);
}
exports.isBeforeIntroductionOfAllianzEssentialsTier = isBeforeIntroductionOfAllianzEssentialsTier;
function isBeforeIntroductionOfAllianzSilverTier(date) {
    return date && moment(date).isBefore(process.env.REACT_APP_ALLIANZ_SILVER_TIER_RELEASE_DATE);
}
exports.isBeforeIntroductionOfAllianzSilverTier = isBeforeIntroductionOfAllianzSilverTier;
function getInteractionPaymentAmount(interaction, isUpfrontInterest, debtCombined) {
    var process = interaction.process;
    var factors = interaction.factors;
    if (process === "mtaPayOffBalance") {
        return factors.payOffPremium;
    }
    else if (isRenewal(process)) {
        return factors.annualPremium;
    }
    else if (debtCombined) {
        return interaction.factors.mtaAndDebtCombinedAdditionalAmount;
    }
    else if (isCustomerPortalMta(process) || isCustomerPortalMtc(process)) {
        if (isUpfrontInterest) {
            return interaction.paymentDetails.instalmentPlan.upfrontInterestCorrectionPayment;
        }
        return (isUpfrontPrice(interaction)) ? factors.upfrontPaymentAmount : factors.additionalPremium;
    }
    else {
        // If execution ever enters here, then we have some process which is not implemented in this method yet, i.e. Support Portal
        return 0;
    }
}
exports.getInteractionPaymentAmount = getInteractionPaymentAmount;
function isUpfrontPrice(interaction) {
    var factors = interaction.factors;
    var annualHasDebt = factors.premiumType === services_1.PREMIUM_TYPE_ANNUAL
        && factors.debtAmount
        && factors.debtAmount !== 0;
    return (interaction.uistate
        && !interaction.uistate.payFullPrice
        && services_1.productHelper.isHomeOrWolfMotor(interaction)
        && factors.premiumType !== services_1.PREMIUM_TYPE_ANNUAL ||
        annualHasDebt);
}
exports.isUpfrontPrice = isUpfrontPrice;
function getTierChangeWording(interaction) {
    var newTier = interaction === null || interaction === void 0 ? void 0 : interaction.coverTier;
    var previousTier = interaction === null || interaction === void 0 ? void 0 : interaction.uistate.previousCoverTier;
    if (!previousTier || newTier === previousTier) {
        return "";
    }
    switch (newTier) {
        case services_1.ALLIANZ:
            return "and upgrade to our Allianz cover, our highest level of comprehensive insurance.";
        case services_1.ALLIANZ_SILVER:
            if (previousTier !== services_1.ALLIANZ) {
                return "and upgrade to Allianz Silver.";
            }
            else {
                return "and change your cover level to Allianz Silver.";
            }
        case services_1.ALLIANZ_ESSENTIALS:
            return "and change your cover level to Allianz Essentials.";
        default:
            return "";
    }
}
exports.getTierChangeWording = getTierChangeWording;
function hasPriceForTier(oldTier, currentCoverTier, tieredFactors) {
    var _a;
    var premiumForTierExists = (_a = tieredFactors === null || tieredFactors === void 0 ? void 0 : tieredFactors.some(function (factor) { return (factor === null || factor === void 0 ? void 0 : factor.tier) === oldTier; })) !== null && _a !== void 0 ? _a : false;
    return (oldTier === currentCoverTier || premiumForTierExists);
}
exports.hasPriceForTier = hasPriceForTier;
function isPolicyHolderNameValid(policyHolderName) {
    var expression = /^[a-z ,.'-]+$/i;
    return expression.test(policyHolderName.firstName) && expression.test(policyHolderName.lastName);
}
exports.isPolicyHolderNameValid = isPolicyHolderNameValid;
function getCoverTierWording(coverTier) {
    switch (coverTier) {
        case services_1.ALLIANZ_ESSENTIALS:
            return "Allianz Essentials";
        case services_1.ALLIANZ_SILVER:
            return "Allianz Silver";
        default:
            return "Allianz";
    }
}
exports.getCoverTierWording = getCoverTierWording;
function isTierNotDeclined(tier, tieredUnderwritingResult) {
    var tierNotDeclined = tieredUnderwritingResult.some(function (UWResult) { return UWResult.tier === tier && UWResult.underwritingFailures.length === 0; });
    return tierNotDeclined;
}
exports.isTierNotDeclined = isTierNotDeclined;
function tierNotCalculatedOrNotDeclined(tier, tieredUnderwritingResult) {
    if (!tieredUnderwritingResult.some(function (tieredUnderwritingResult) { return tieredUnderwritingResult.tier === tier; })) {
        return true;
    }
    else {
        return isTierNotDeclined(tier, tieredUnderwritingResult);
    }
}
exports.tierNotCalculatedOrNotDeclined = tierNotCalculatedOrNotDeclined;
function getEligibleTiers(interaction) {
    var eligibleTiers = [services_1.ALLIANZ_ESSENTIALS, services_1.ALLIANZ_SILVER, services_1.ALLIANZ];
    if (!interaction.tieredUnderwritingResult) {
        if (!interaction.underwritingResult || interaction.underwritingResult.length === 0) {
            return [services_1.ALLIANZ];
        }
        else {
            return [];
        }
    }
    return eligibleTiers.filter(function (tier) {
        return tierNotCalculatedOrNotDeclined(tier, interaction.tieredUnderwritingResult);
    });
}
exports.getEligibleTiers = getEligibleTiers;
function handleChanged(key, interaction, initVal, val) {
    journey_services_1.ObjectManipulator.setField(key, interaction, val);
    if (!interaction.uistate.trackChanges) {
        return;
    }
    if (initVal === val) {
        removeChange(key, interaction);
    }
    else {
        pushChange(key, interaction);
    }
}
exports.handleChanged = handleChanged;
function pushChange(key, interaction) {
    var changesName = "uistate.changes";
    var changes = journey_services_1.ObjectManipulator.fetchFieldValue(changesName, interaction);
    if (!Array.isArray(changes)) {
        changes = [];
    }
    if (!changes.includes(key)) {
        changes.push(key);
        interaction.uistate.changes = changes;
    }
}
exports.pushChange = pushChange;
function removeChange(key, interaction) {
    var changesName = "uistate.changes";
    var changes = journey_services_1.ObjectManipulator.fetchFieldValue(changesName, interaction);
    if (!Array.isArray(changes)) {
        return;
    }
    if (changes.includes(key)) {
        changes = changes.filter(function (item) { return item !== key; });
        interaction.uistate.changes = changes;
    }
}
exports.removeChange = removeChange;
//# sourceMappingURL=commonFunctions.js.map


//////////////////
// WEBPACK FOOTER
// ../falcon-plugins/plugin-falcon-journey/dist/commonFunctions.js
// module id = 6
// module chunks = 0